module.exports = __webpack_public_path__ + "static/img/1963.51111160.jpg";